(function (root) {
  const complete = values => values.length > 0 && values.every(value => {
    try { return new URL(value).protocol === 'https:'; } catch { return false; }
  });
  function check({ready, handle, options = [], fields = []}) {
    if (!ready) return 'upload_wait';
    const range = options.map(value => String(value).match(/(\d+)\s*(?:to|[–-])\s*(\d+)/i)).find(Boolean);
    if (!range) return 'upload_wait';
    const minimum = handle === 'the-travel-edition' ? 40 : Number(range[1]);
    let maximum = handle === 'the-travel-edition' && Number(range[2]) === 70 ? 60 : Number(range[2]);
    if (handle === 'custom-books' && minimum === 40 && maximum === 65) maximum = 70;
    const photos = fields.find(field => field.kind === 'photos');
    const cover = fields.find(field => field.kind === 'cover');
    if (!photos || !cover) return 'upload_wait';
    if (photos.invalid || photos.values.length < minimum || photos.values.length > maximum) return 'upload_count';
    if (!complete(photos.values)) return 'upload_wait';
    const coverOptional = handle === 'custom-books' || handle === 'the-travel-edition';
    if (cover.invalid || cover.values.length > 1 || (!coverOptional && !cover.values.length)) return 'upload_cover';
    if (cover.values.length && !complete(cover.values)) return 'upload_wait';
    return '';
  }
  const api = {check};
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MaissonOrder = api;
})(typeof window === 'object' ? window : globalThis);
